<template>
  <div class="glosario">
    <Titulo titulo="Mis mensajes" />
    <b-row>
      <b-col cols="12" md="8">
        <div class="margin-lateral">
          <div>
            <div v-for="(mensaje, index) in misMensajes" :key="index" class="listas mb-3">
              <h3 class="color-secundary">{{mensaje.titulo}}</h3>
              <div v-html="mensaje.mensaje"></div>
              <hr class="background-secundary mt-4 mb-4" />
            </div>
          </div>
        </div>
      </b-col>
      <BannerRight />
    </b-row>
    <!--  -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "MisMensajes",
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    BannerRight: () => import("@/containers/layout/banner-right.vue")
  },
  computed: {
    ...mapGetters({
      misMensajes: "pages/misMensajes"
    })
  }
};
</script>